import * as actionTypes from './actionTypes';

export const fetchDashboardData = (payload) => ({
    type: actionTypes.FETCH_DASHBOARD_DATA,
    payload
});